"use client";

import React from "react";
import Image from "next/image";
import Navbar from "@/components/layout/navbar/Navbar";
import Breadcrumb from "@/components/Common/Breadcrumb";

const Hero: React.FC = () => {
  return (
    <section className="relative w-full sm:min-h-51.25 bg-[#1B365E] flex flex-col items-center justify-start mb-8">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <Image
          src="/assets/Gradient-Bckg.svg"
          alt="Hero Background"
          fill
          priority
          className="object-cover w-full h-full"
        />
        <div className="absolute inset-0 bg-[#1B365E]/55 sm:hidden" aria-hidden="true" />
      </div>

      <div className="relative z-100 w-full">
        <Navbar />
      </div>

      <div className="relative z-10 px-4 xl:px-10 pt-13.5 sm:pt-22 mb-12 sm:mb-6.5 w-full mx-auto">
        <Breadcrumb />
        <h1 className="font-red-hat font-normal text-[30px] sm:text-[48px] md:text-[60px] text-white leading-9.25 sm:leading-12.5 md:leading-19.75 tracking-[0.2px] mb-4.25 mx-auto">
          Les Avis & Témoignages
        </h1>
      </div>

      <div className="flex items-center bg-white rounded-[40px] border-b border-[#40BFDE] py-3 px-4 justify-center absolute left-1/2 z-10 -translate-x-1/2 -bottom-5">
        <Image
          src="/assets/small-logo.svg"
          alt="small-logo"
          title="small-logo"
          width={30}
          height={17}
        />
      </div>
    </section>
  );
};

export default Hero;
